import React from 'react';

import { ChartGanttIcon } from '@adsk/alloy-react-icon';

import { ScheduleActivityNestedOptionsLabel } from '../components';
import { ScheduleActivityReferencePickerPlugin } from '../types';

export const nestedOptions: NonNullable<ScheduleActivityReferencePickerPlugin>['nestedOptions'] =
  {
    label: <ScheduleActivityNestedOptionsLabel />,
    renderIcon: ChartGanttIcon.renderIcon,
    key: 'schedule',
    nestedCategoryKey: 'schedule',
  };
